import React, { Component } from 'react'
import LoadingLogo from "../../images/loadinglogo.PNG"
import Spinner from "../../images/spinner.png"

export class PoModal extends Component {


    render() {  
        let rejectContent = ""
        let returnContent = ""
        let approveContent = ""
        let transmitContent = ""
        let reviewContent = ""
        let onHoldContent = ""
        
        if(this.props.onHoldRequest === true){
            onHoldContent = <div className="modalContent">
            <h4 className="returnHeader">On Hold</h4>
                 <form action="">
                     <div className="returnLabel">
                         <p>Message:</p>
                         <small id="returnValidation"></small>
                     </div>
                     <textarea name="reason"
                             id="returnMessage"
                             onChange={this.props.handleChangeState}
                     ></textarea>
                     <div className="modalBtnContainer">
                             <button className="cancelModalBtn" onClick={this.props.closeReturnModal}>CANCEL</button>
                             <button className="returnBtnDept" onClick={this.props.handleOnHold}>CONFIRM</button>
                     </div>
                         </form>   
             </div>  
        }

        if(this.props.endorseRequest === true){
            reviewContent =<div className="modalContent">
            <h4 className="returnHeader">In Process</h4>
                 <div id="approveMessage">
                     <h5>You are about to mark this request as In Process. Please confirm.
                     </h5>
                 </div>
                     <div className="modalBtnContainer">
                             <button className="cancelModalBtn" onClick={this.props.closeReturnModal}>CANCEL</button>
                             <button
                                //href={this.props.crfLink} 
                             className="returnBtnDept" onClick={this.props.handleInprocess}>
                                 CONFIRM
                            </button>           
                     </div>
             </div>  
        }

        if(this.props.reviewRequest === true){
            reviewContent =<div className="modalContent">
            <h4 className="returnHeader">Mark as Review</h4>
                 <div id="approveMessage">
                     <h5>You are about to mark this request as reviewed which means that you will become liable
                         in the process flow.
                     </h5>
                 </div>
                     <div className="modalBtnContainer">
                             <button className="cancelModalBtn" 
                                     onClick={this.props.closeReturnModal}>CANCEL
                             </button>
                             <a href={this.props.crfLink} className="returnBtnDept" onClick={this.props.handleReviewed}>CONFIRM</a>           
                     </div>
             </div>  
        }

        if(this.props.transmitRequest === true){
            transmitContent =<div className="modalContent">
            <h4 className="returnHeader">Mark as Transmitted</h4>
                 <div id="approveMessage">
                     <h5>You are about to mark this request as transmitted which means that you will become liable
                         in the process flow. Please make sure that you already have the hard copy of the documents
                         to be review.
                     </h5>
                 </div>
                     <div className="modalBtnContainer">
                             <button type="button" className="cancelModalBtn" onClick={this.props.closeReturnModal}>CANCEL</button>
                             <a  href={this.props.crfLink} className="returnBtnDept" onClick={this.props.handleTransmitted}>CONFIRM</a>
              
                     </div>
                   
             </div>  
            
        }

        if(this.props.rejectRequest === true){
            returnContent = <div className="modalContent">
            <h4 className="returnHeader">Reject This Request</h4>
                 <form action="">
                     <div className="returnLabel">
                         <p>Reason:</p>
                         <small id="returnValidation"></small>
                     </div>
                     <textarea name="reason"
                             id="returnMessage"
                             onChange={this.props.handleChangeState}
                     ></textarea>
                     <div className="modalBtnContainer">
                             <button className="cancelModalBtn" onClick={this.props.closeReturnModal}>CANCEL</button>
                             <a a href={this.props.crfLink} className="returnBtnDept" onClick={this.props.handleRejectRequest}>REJECT</a>
                     </div>
                         </form>   
             </div>  
        }

        if(this.props.returnRequest === true){
            returnContent = <div className="modalContent">
            <h4 className="returnHeader">Returning a Request</h4>
                 <form action="">
                     <div className="returnLabel">
                         <p>Reason:</p>
                         <small id="returnValidation"></small>
                     </div>
                     <textarea name="reason"
                             id="returnMessage"
                             onChange={this.props.handleChangeState}
                     ></textarea>
                     <div className="modalBtnContainer">
                             <button className="cancelModalBtn" onClick={this.props.closeReturnModal}>CANCEL</button>
                             <button className="returnBtnDept" onClick={this.props.handleReturnRequest}>CONFIRM</button>
                     </div>
                         </form>   
             </div>  
        }

        if(true){
            approveContent =<div className="modalContent">
            <h4 className="returnHeader">Approve Request</h4>
                 <div id="approveMessage">
                     <h5>You are about to approve this request. Please make sure that you already reviewed
                         the request.
                     </h5>
                 </div>
                     <div className="modalBtnContainer">
                             <button className="cancelModalBtn" onClick={this.props.closeReturnModal}>CANCEL</button>
                             <a href={this.props.crfLink} className="returnBtnDept" onClick={this.props.handleApproveCrf}>CONFIRM</a>
                     </div>
             </div>  
        }

        if(this.props.editCrfDetails === true){
            approveContent =<div className="modalContent">
            <h4 className="returnHeader">edit Details Request</h4>
             </div>  
        }


        return (
            <div id="modalBody" className="modalBody">
            <div className="modalContainer" >
               <div className="modalbg2" onClick={this.props.closeReturnModal}></div>
                
                
                <div className="modalContent2">
                  <img className="loadingLogo" src={LoadingLogo} alt=""/>
                   <img className="spinner" src={Spinner} alt=""/>
                 </div>  
                
            </div>
     
      </div>
        )
    }
}

export default PoModal
